import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Storage } from '@ionic/storage';
import { HubspotService } from 'src/app/services/hubspot.service';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  selector: 'fun-overview-priority-group-vinculate',
  templateUrl: './overview-priority-group-vinculate.component.html',
  styleUrls: ['./overview-priority-group-vinculate.component.scss'],
})
export class OverviewPriorityGroupVinculateComponent implements OnInit {

  @Input() stage: any;
  @Output() public removeComponentEvent = new EventEmitter<any>();
  public sendXHR = 'colorFull-disabled';
  loading = false;
  step = 'group_list';
  backCta = 'ghost';
  groupSelected: any;
  profile: any;
  expandedGroups: { [key: number]: boolean } = {};

  constructor(private chdRef: ChangeDetectorRef, private storage: Storage, private hubspotService: HubspotService) { }

  ngOnInit() {
    this.chdRef.detectChanges();
  }


  get groupedPriorityGroups(): { priority: number, items: any[] }[] {
    if (!this.stage?.priority_groups) return [];

    const sorted = this.stage.priority_groups.slice().sort((a: any, b: any) => a.priority - b.priority);

    const groups: { priority: number, items: any[] }[] = [];
    sorted.forEach((pg: any) => {
      let group = groups.find(g => g.priority === pg.priority);
      if (!group) {
        group = { priority: pg.priority, items: [] };
        groups.push(group);
      }
      group.items.push(pg);
    });

    return groups;
  }

  selectGroup(group: any) {
    this.groupSelected = group;
    this.sendXHR = 'colorFull';
    this.chdRef.detectChanges();
  }

  next() {
    this.loading = true;
    let username;
    this.storage.get('USERNAME').then(val => {
      username = val;
      this.sendVinculationToHubspot(val);
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  sendVinculationToHubspot(username: string) {
    const body = `Solicitud de vinculación a grupo prioritario.`;
    const subject = `${username} ha solicitado unirse al siguiente grupo prioritario: ${this.groupSelected.name}.`;
    this.hubspotService.createTask(subject, body).subscribe(() => {
      this.loading = false;
      this.chdRef.detectChanges();
    }, error => {
      console.log(error, 'error')
      // this.loading = false;
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  prev() {
    this.removeComponentEvent.emit();
    this.chdRef.detectChanges();
  }

  parseValues(value: string): string[] {
    if (!value) return [];
    return value.split(',').map(function(v) { return v.trim(); }).filter(function(v) { return v !== ''; });
  }

  toggleExpand(pgId: number, event: Event): void {
    event.stopPropagation();
    this.expandedGroups[pgId] = !this.expandedGroups[pgId];
    this.chdRef.detectChanges();
  }

  isExpanded(pgId: number): boolean {
    return !!this.expandedGroups[pgId];
  }

}
